<template>
  <div v-show="isActive" class="container m-t-10">
    <div :class="className" role="alert">
      <button class="close" @click="hideMessage"></button>
      <ul v-if="content.constructor === Array">
        <li v-for="message in content">
          {{ message }}
        </li>
      </ul>
      <ul v-else><li>{{ content }}</li></ul>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'
export default{
  computed: {
    ...mapGetters({
      content: 'message/content',
      isActive: 'message/isActive',
      type: 'message/type'
    }),
    className () {
      return `alert alert-${this.type}`
    }
  },
  methods: {
    hideMessage() {
      this.$store.dispatch('message/disable')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Message.vue